/**
 * Keeps the floating chat button (an app widget, so no markup of ours) out of
 * the way of what people buy with:
 *  - it sits above the sticky add to cart, with a gap, instead of on it;
 *  - while it would cover a price or a button it fades out and stops taking
 *    taps, and comes back as soon as the page scrolls on.
 * The side is mirrored for RTL in soah-spacing.css.
 *
 * The positioned element is an app wrapper whose class says nothing about
 * WhatsApp, so we walk up from an element that does to its fixed ancestor.
 */
(function () {
  var GAP = 8; // between the sticky bar and the button
  var MARGIN = 6; // clearance kept around the button
  var AVOID = '[class*="price"], [class*="was"], [class*="compare"], s, del, .product-form__submit, .soah-finish__card, .full-unstyled-link, .cc-mini, .slider-button, .soah-set__step, .soah-set__radio, .quantity__button, .soah-sticky-atc__cta, .cart__checkout-button, .button';
  var wrap = null;
  var base = null;
  var watching = false;
  var pending = false;

  function find() {
    if (wrap && document.body.contains(wrap)) return wrap;
    // Several elements can mention WhatsApp (the subscription widget has its
    // own button); the floating one is the first with a fixed ancestor.
    var seeds = document.querySelectorAll('[class*="whatsapp" i],[id*="whatsapp" i],[class*="chat-button" i],[id*="chat-button" i]');
    wrap = null;
    for (var i = 0; i < seeds.length && !wrap; i++) {
      var el = seeds[i];
      while (el && el !== document.body && getComputedStyle(el).position !== 'fixed') el = el.parentElement;
      if (el && el !== document.body) wrap = el;
    }
    if (wrap && base === null) {
      var b = parseFloat(getComputedStyle(wrap).bottom);
      base = isNaN(b) ? 16 : b;
    }
    return wrap;
  }

  function stickyHeight() {
    var bar = document.querySelector('.soah-sticky-atc.is-visible:not(.is-suppressed)');
    return bar ? bar.offsetHeight : 0;
  }

  function update() {
    pending = false;
    var el = find();
    if (!el) return;
    var h = stickyHeight();
    el.style.setProperty('bottom', base + (h ? h + GAP : 0) + 'px', 'important');

    var r = el.getBoundingClientRect();
    var left = r.left - MARGIN, right = r.right + MARGIN, top = r.top - MARGIN, bottom = r.bottom + MARGIN;
    var hit = false;
    var list = document.querySelectorAll(AVOID);
    for (var i = 0; i < list.length && !hit; i++) {
      if (el.contains(list[i])) continue;
      var q = list[i].getBoundingClientRect();
      if (!q.width || !q.height) continue;
      hit = q.right > left && q.left < right && q.bottom > top && q.top < bottom;
    }
    // Written on every pass: the app rewrites its own inline opacity, which
    // drops ours, so a remembered state would go stale.
    var opacity = hit ? '0' : '1';
    if (el.style.getPropertyValue('opacity') !== opacity || el.style.getPropertyPriority('opacity') !== 'important') {
      el.style.setProperty('opacity', opacity, 'important');
      el.style.setProperty('pointer-events', hit ? 'none' : 'auto', 'important');
    }
    if (!watching) {
      watching = true;
      new MutationObserver(schedule).observe(el, { attributes: true, attributeFilter: ['style'] });
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('soah-set:change', schedule);
  document.addEventListener('soah-sticky:change', schedule);
  // The app injects the widget late; look for it for a few seconds.
  var tries = 0;
  var t = setInterval(function () {
    schedule();
    if (++tries > 30) clearInterval(t);
  }, 300);
})();
